// extracted by mini-css-extract-plugin
module.exports = {"themeSwitcher":"ThemeSwitcher-module--themeSwitcher--1gbnJ"};